export function formatMask(): string {
        return abp.localization.currentLanguage.name === 'it' ? 'DD/MM/YYYY' : 'MM/DD/YYYY';
}

export function validDateMaskRegex(value: string) {
    return abp.localization.currentLanguage.name === 'it' ? new RegExp(/^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/).test(value)
        : new RegExp(/^(((0)[0-9])|[0-2][0-9]|((1)[0-2]))(\/)([0-2][0-9]|(3)[0-1])(\/)\d{4}$/).test(value);
}

